import { observer } from 'mobx-react';
import { Component } from 'react';

@observer
class Code extends Component {
    render() {
        if (this.props.code !== undefined && this.props.code !== null && this.props.code !== '0000000000') {
            return (this.getCode())
        }
        else return '';
    }

    getCode() {
        return this.props.code.substr(0, 1) === '[' ? this.props.code :
            this.props.code.substr(0, 4) + ' ' +
            this.props.code.substr(4, 2) + ' ' +
            this.props.code.substr(6, 3) + ' ' +
            this.props.code.substr(9, 1) + ' ' +
            this.props.code.substr(10)
    }
}


export default Code;


// WEBPACK FOOTER //
// ./src/components/Code.js